'use strict';

var _ = require('lodash');
var ChartSponsorForecastFlightDataProviderService = function ChartSponsorForecastFlightDataProviderService($filter, dataRetrieverService, constants, colorScales, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var colorScale20 = colorScales.colorScale20();
  var colorScaleBlank20 = colorScales.colorScaleBlank20();
  function retrieveData(market) {
    return dataRetrieverService.getDataRetriever(constants.SCHEDULE_CHANGE_SCREEN, constants.SPONSOR_FORECAST_FLIGHT_MODE).retrieveSimpleData(constants.SPONSOR_FORECAST_FLIGHT_MODE, undefined, [market.origin, market.destination]);
  }
  function transformData(data) {
    if (data === undefined) {
      return {
        data: [],
        legend: undefined
      };
    }
    var index = 0;
    var result = [];
    var colorMap = {};
    var blankColorMap = {};
    data.forEach(function (dateSchedule) {
      var dateObj = {
        date: dateSchedule.departureDate,
        stackLabel: rmMomentFormat(dateSchedule.departureDate, 'DATE_ISO'),
        flights: []
      };
      dateSchedule.legSchedules.forEach(function (legSchedule) {
        var flightId = legSchedule.carrier + legSchedule.number;
        var fillColor = colorMap[flightId];
        var blankColor = blankColorMap[flightId];
        if (!fillColor) {
          fillColor = colorMap[flightId] = colorScale20(index % 20);
          blankColor = blankColorMap[flightId] = colorScaleBlank20(index % 20);
          index++;
        }
        dateObj.flights.push({
          time: momentService.of(legSchedule.legDepartureTime, momentService.FIELD.DEPARTURE_TIME, 'HHmm'),
          fill: fillColor,
          originalFill: fillColor,
          blankColor: blankColor,
          flightId: flightId,
          flightNumber: legSchedule.number,
          legBusinessId: legSchedule.legBusinessId,
          tileLabel: flightId + '-id' + legSchedule.legBusinessId
        });
      });
      result.push(dateObj);
    });
    var legendMapped = _.map(colorMap, function (color, label) {
      return {
        label: label,
        fill: color
      };
    });
    return {
      data: result,
      legend: legendMapped
    };
  }
  function getData(leg) {
    return retrieveData(leg).then(transformData);
  }
  return {
    getData: getData
  };
};
ChartSponsorForecastFlightDataProviderService.$inject = ['$filter', 'DataRetrieverService', 'DataRetrieverConstantsService', 'RmColorScales', 'MomentService'];
module.exports = ChartSponsorForecastFlightDataProviderService;